import * as React from 'react';
import Tabs from './Tabs';
import TabLink from './TabLink';

export interface VerticalTabEntry {
  requiredLine: string;
  optionalLine?: string;
  to: string;
  disabled?: boolean;
  onClick?: () => void;
  exact?: boolean;
}
interface VerticalTabsProps {
  size?: string;
  entries: VerticalTabEntry[];
}

const VerticalTabs = ({ size, entries }: VerticalTabsProps) => {
  return (
    <Tabs size={size || 'large'}>
      {entries?.map((entry: VerticalTabEntry) => (
        <TabLink
          key={entry.to}
          to={entry.to}
          exact={entry.exact}
          requiredLine={entry.requiredLine}
          optionalLine={entry.optionalLine}
          disabled={entry.disabled}
          onLinkClick={() => {
            if (entry.onClick) {
              entry.onClick();
            }
          }}></TabLink>
      ))}
    </Tabs>
  );
};

export default VerticalTabs;
